import { BaseModel } from "@blue-chip/core";

import Project from "./Project";

export default class Scale extends BaseModel {
  static get hasMany() {
    return [Project];
  }
}
